module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/is-object.js
// module id = 31
// module chunks = 0